import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import { Box, Button } from '@mui/material';
import { useAppDispatch } from '../../hooks';
import { setIranConflictActive } from '../../state/focus-region/focus-region.slice';

interface Props {
  /** Optional callback invoked after the focus region is deactivated.
   *  Use this when the hosting panel needs additional cleanup (e.g. closing
   *  the panel and navigating away), while still using the shared button. */
  onAfterExit?: () => void;
}

/** Exit button shown in panels when Focus Region view is active. */
function ExitFocusRegionButton({ onAfterExit }: Props) {
  const dispatch = useAppDispatch();

  const handleClick = () => {
    dispatch(setIranConflictActive(false));
    onAfterExit?.();
  };

  return (
    <Box sx={{ px: 2, pt: 1, pb: 0.5 }}>
      <Button
        data-testid="exit-focus-region-button"
        variant="outlined"
        size="small"
        startIcon={<PowerSettingsNewIcon />}
        onClick={handleClick}
        fullWidth
      >
        Exit &apos;Focus Region&apos; View
      </Button>
    </Box>
  );
}

ExitFocusRegionButton.defaultProps = {
  onAfterExit: undefined,
};

export default ExitFocusRegionButton;
